module.exports = __webpack_public_path__ + "static/img/a205.003216c6.png";